export default {
  nav: {
    lite: 'Lite',
    new: 'جديد',
  },
  footer: {
    links: {
      lite: 'Geofleet Lite',
    },
  },
  litePage: {
    seoTitle: 'Geofleet Lite — برنامج بسيط لإدارة التوصيل للشركات الصغيرة',
    seoDescription:
      'Geofleet Lite حل للتوصيل من موقع واحد يبدأ من 49$ شهرياً مع 3 سائقين و500 طلب. وتضيف Lite Plus تخطيط المسارات والتخصيص التلقائي وواتساب وواجهة API مقابل 99$، وتضيف Lite Autopilot ‏AI Copilot وAutopilot مقابل 179$. وفّر حتى 20% مع الفوترة السنوية.',
    breadcrumb: 'Geofleet Lite',

    heroBadge: 'Geofleet Lite',
    heroEyebrow: 'إدارة توصيل بسيطة للشركات الصغيرة',
    heroTitle: 'موقعك. سائقوك.',
    heroTitleHighlight: 'كل عمليات التوصيل على شاشة واحدة.',
    /** Direct answer paragraph — quotable by search and AI answer engines. */
    heroLead:
      'Geofleet Lite برنامج توصيل للشركات الصغيرة التي لديها عدد قليل من السائقين ونقطة استلام واحدة: متجر أو مطبخ أو صيدلية أو مستودع. أضف الطلبات، وخطّط مسارات اليوم، وتابع السائقين على خريطة مباشرة، وأرسل لكل عميل رابط تتبع. لا جداول بيانات، ولا ملاحقة في مجموعات WhatsApp.',
    ctaPrimary: 'ابدأ مع Lite',
    ctaSecondary: 'شاهد كيف يعمل',
    heroFacts: [
      { icon: 'ri-price-tag-3-line', label: 'خطط من 49$ شهرياً' },
      { icon: 'ri-user-line', label: '3 سائقين مشمولين' },
      { icon: 'ri-file-list-3-line', label: '500 طلب مشمول' },
    ],
    heroVisualAlt: 'لوحة تحكم Geofleet Lite تعرض طلبات اليوم وحالة التوصيل وملخص Copilot وتنبيهات التأخير',
    heroDriverAlt: 'تطبيق السائق في Geofleet Lite يعرض المحطة الحالية والمبلغ المطلوب تحصيله ومحطات اليوم',
    heroTrackAlt: 'صفحة تتبع العميل تعرض موقع السائق المباشر ووقت الوصول',
    screenshotOf: 'شاشة Geofleet Lite: {{title}}',

    problemKicker: 'هل يبدو هذا مألوفاً؟',
    problemTitle: 'معظم فرق التوصيل الصغيرة تعمل عبر مجموعات الدردشة والذاكرة',
    problems: [
      { icon: 'ri-whatsapp-line', title: 'طلبات متناثرة بين المحادثات', text: 'تصل الطلبات عبر الهاتف وWhatsApp ومتجرك، ثم ينسخها أحدهم يدوياً إلى جدول.' },
      { icon: 'ri-route-line', title: 'مسارات مخططة في الذهن', text: 'يتنقل السائقون في المدينة بشكل عشوائي لأن لا أحد لديه وقت لترتيب 30 محطة يدوياً.' },
      { icon: 'ri-phone-line', title: 'مكالمات "أين طلبي؟"', text: 'العميل يتصل بالمتجر، والمتجر يتصل بالسائق، والجميع ينتظر.' },
      { icon: 'ri-money-dollar-circle-line', title: 'نقد لا تتطابق حساباته', text: 'تُسوّى مبالغ الدفع عند الاستلام في نهاية اليوم اعتماداً على الملاحظات والذاكرة.' },
    ],

    setupKicker: 'ابدأ اليوم',
    setupTitle: 'خمس خطوات سريعة، ثم أرسل أول توصيلة',
    setupIntro: 'لا يطلب Lite إلا ما يحتاجه لتشغيل عمليات التوصيل. ويمكنك تغيير كل شيء لاحقاً من الإعدادات.',
    setupSteps: [
      { icon: 'ri-store-2-line', title: 'نشاطك التجاري', text: 'الاسم والشعار ورقم الدعم، ليتعرّف عليك عملاؤك.' },
      { icon: 'ri-map-pin-2-line', title: 'موقع الاستلام', text: 'موقعك الرئيسي: حيث يبدأ كل مسار وينتهي.' },
      { icon: 'ri-time-line', title: 'ساعات العمل', text: 'الأوقات التي يوصّل فيها سائقوك.' },
      { icon: 'ri-shield-check-line', title: 'قواعد التوصيل', text: 'إثبات التسليم، وإعادة المحاولة، وأرقام الطلبات.' },
      { icon: 'ri-message-3-line', title: 'رسائل العملاء', text: 'اختر SMS أو WhatsApp أو البريد الإلكتروني لروابط التتبع.' },
    ],

    dayKicker: 'يوم مع Lite',
    dayTitle: 'كل ما تحتاجه شركة توصيل من موقع واحد، على شاشة واحدة',
    dayItems: [
      {
        icon: 'ri-file-list-3-line',
        title: 'استقبال الطلبات',
        text: 'أضف طلباً في ثوانٍ مع البحث عن العنوان وتحديد موعد التوصيل ومبلغ الدفع عند الاستلام، أو ارفع ملف CSV لطلبات اليوم كله.',
        points: ['إكمال تلقائي للعناوين', 'بحث عن العملاء الدائمين', 'استيراد CSV'],
      },
      {
        icon: 'ri-route-line',
        title: 'تخطيط المسارات',
        text: 'اختر طلبات اليوم والسائقين، واضغط تحسين، ثم اسحب المحطات لضبطها قبل نشرها على هواتف السائقين.',
        points: ['تحسين بنقرة واحدة انطلاقاً من موقعك', 'إعادة ترتيب المحطات أو نقلها', 'النشر إلى تطبيق السائق'],
      },
      {
        icon: 'ri-map-pin-time-line',
        title: 'التتبع المباشر',
        text: 'شاهد كل سائق وكل طلب على خريطة واحدة مع أوقات وصول مباشرة، وأعد الإسناد أو شارك رابطاً من الخريطة مباشرة.',
        points: ['عرض السائقين والطلبات', 'وقت وصول مباشر لكل محطة', 'قائمة بما يحتاج إلى انتباهك'],
      },
      {
        icon: 'ri-shield-check-line',
        title: 'إثبات التسليم وتحصيل النقد',
        text: 'يسجّل السائقون إثبات التسليم عند الباب والمبالغ النقدية المحصّلة. ترى من يحمل كم، وتسوّي الحساب بلمسة واحدة.',
        points: ['صورة أو توقيع أو اسم المستلم', 'النقد الذي يحمله كل سائق', 'تسوية النقد وتنزيل التقارير'],
      },
    ],

    hubKicker: 'مصمم لموقع واحد',
    hubTitle: 'مصمم وفق طريقة عمل شركات التوصيل الصغيرة فعلاً',
    hubPoints: [
      { icon: 'ri-home-4-line', title: 'نقطة استلام واحدة تُضبط مرة واحدة', text: 'كل طلب ينطلق من موقعك، فلا تحتاج أبداً لكتابة عنوان الاستلام.' },
      { icon: 'ri-user-smile-line', title: 'رابط تتبع لعملائك', text: 'بشعارك وألوانك. دون أن يحتاج العملاء إلى تثبيت أي تطبيق.' },
      { icon: 'ri-smartphone-line', title: 'تطبيق سائق بسيط وواضح', text: 'المحطة الحالية، والملاحة، والاتصال، وإثبات التسليم. هذا كل شيء.' },
      { icon: 'ri-bar-chart-2-line', title: 'أرقام اليوم في لمحة', text: 'ما تم تسليمه، وما فشل، وما وصل في موعده، وما يحتاج إليك بعد ذلك، بمجرد فتح Lite.' },
    ],

    industriesTitle: 'الأكثر استخداماً لدى',
    industries: [
      { label: 'المطاعم والمطابخ السحابية', href: '/industries/restaurants' },
      { label: 'الصيدليات', href: '/industries/pharmacies' },
      { label: 'البقالة والمتاجر المظلمة', href: '/industries/grocery' },
      { label: 'محلات الزهور', href: '/industries/flowers' },
      { label: 'المغاسل', href: '/industries/laundry' },
      { label: 'توصيل المياه', href: '/industries/water' },
    ],

    compareKicker: 'Lite أم المنصة الكاملة؟',
    compareTitle: 'ابدأ مع Lite. وانتقل إلى Geofleet دون أن تبدأ من الصفر.',
    compareIntro:
      'يعمل Lite على منصة Geofleet نفسها. عندما تضيف موقعاً ثانياً أو تحتاج إلى التوزيع بالذكاء الاصطناعي، تُرقّي خطتك وتحتفظ بكل طلباتك وسائقيك وسجلّك.',
    compareColFeature: 'ما تحتاجه',
    compareColLite: 'Geofleet Lite',
    compareColPlatform: 'Geofleet Command',
    compareRows: [
      { feature: 'السعر', lite: '49$ Lite · 99$ Lite Plus · 179$ Lite Autopilot', platform: 'من 19$ لكل سائق / شهرياً' },
      { feature: 'السائقون', lite: '3 · 10 · 25 مشمولة', platform: 'الحد الأدنى 10 سائقين' },
      { feature: 'الطلبات', lite: '500 · 1,000 · 2,000 شهرياً', platform: '5,000+ حسب الخطة والسائقين' },
      { feature: 'المواقع', lite: 'موقع واحد', platform: 'مواقع متعددة ومراحل متعددة' },
      { feature: 'تخطيط المسارات، والتتبع المباشر، وإثبات التسليم', lite: 'yes', platform: 'yes' },
      { feature: 'روابط تتبع للعملاء', lite: 'yes', platform: 'yes' },
      { feature: 'Shopify وWooCommerce', lite: 'من Lite Plus', platform: 'من Professional' },
      { feature: 'تخطيط المسارات والتخصيص التلقائي', lite: 'من Lite Plus', platform: 'yes' },
      { feature: 'الطلبات والأتمتة عبر واتساب', lite: 'من Lite Plus', platform: 'yes' },
      { feature: 'واجهة API وخطافات الويب', lite: 'من Lite Plus', platform: 'yes' },
      { feature: 'AI Copilot وAutopilot', lite: 'Lite Autopilot', platform: 'من Professional' },
      { feature: 'مجموعة وكلاء الذكاء الاصطناعي الكاملة', lite: 'no', platform: 'yes' },
      { feature: 'التخصيص لشركات الشحن، واتفاقيات مستوى الخدمة، وAI Command Centre', lite: 'no', platform: 'yes' },
    ],
    compareYes: 'مُتضمَّن',
    compareNo: 'غير مُتضمَّن',
    compareCta: 'قارن كل الخطط',

    guidesTitle: 'أدلة للفرق التي تعمل من موقع واحد',
    guides: [
      { label: 'تعرّف على Geofleet Lite', href: '/blog/introducing-geofleet-lite' },
      { label: 'إدارة التوصيل من موقع واحد: دليل يومي', href: '/blog/single-hub-delivery-management-guide' },
      { label: 'تدير التوصيل عبر مجموعة واتساب؟ متى يحين وقت التغيير', href: '/blog/whatsapp-group-delivery-management-alternative' },
      { label: 'كيف تخطط مسارات التوصيل لشركة صغيرة', href: '/blog/how-to-plan-delivery-routes-small-business' },
    ],

    faqTitle: 'الأسئلة الشائعة حول Geofleet Lite',
    faqs: [
      {
        question: 'ما هو Geofleet Lite؟',
        answer:
          'Geofleet Lite نسخة مبسّطة من Geofleet للشركات الصغيرة التي توصّل من موقع واحد. يغطي الطلبات، وتخطيط المسارات، وتتبع السائقين مباشرة، وروابط التتبع للعملاء، وإثبات التسليم، وإدارة الدفع عند الاستلام.',
      },
      {
        question: 'كم يكلّف Geofleet Lite؟',
        answer: 'تبلغ تكلفة Lite ‏49$ شهرياً وتشمل 3 سائقين و500 طلب. وتبلغ Lite Plus ‏99$ وتشمل 10 سائقين و1,000 طلب. وتبلغ Lite Autopilot ‏179$ وتشمل 25 سائقاً و2,000 طلب. توفر الفوترة ربع السنوية نحو 10% والسنوية حتى 20%. والخطط الثلاث مخصصة لموقع واحد فقط.',
      },
      {
        question: 'هل Geofleet Lite مجاني؟',
        answer: 'لا. تبدأ Lite من 49$ شهرياً مع 3 سائقين و500 طلب. يمكنك تجربتها لمدة 7 أيام مع ما يصل إلى 100 طلب.',
      },
      {
        question: 'لمن صُمّم Geofleet Lite؟',
        answer:
          'للمطاعم والصيدليات ومحلات البقالة ومحلات الزهور والمغاسل وموزعي المياه وغيرها من الأنشطة المحلية التي ترسل سائقيها من متجر أو مطبخ أو مستودع واحد.',
      },
      {
        question: 'هل يحتاج سائقيّ إلى تطبيق خاص؟',
        answer: 'يستخدم السائقون تطبيق السائق من Geofleet على هواتفهم لرؤية محطاتهم والملاحة وتسجيل إثبات التسليم. أما العملاء فلا يحتاجون إلى أي تطبيق، إذ يصلهم رابط تتبع.',
      },
      {
        question: 'ماذا يحدث عندما يصبح Lite غير كافٍ لي؟',
        answer:
          'يعمل Lite على المنصة نفسها التي يعمل عليها Geofleet. عندما تحتاج إلى مزيد من السائقين أو المواقع أو وكلاء إرسال بالذكاء الاصطناعي، تنتقل إلى خطة Geofleet مدفوعة وتحتفظ بكل بياناتك.',
      },
      {
        question: 'هل يمكنني استيراد طلباتي الحالية؟',
        answer: 'نعم. أضف الطلبات واحداً تلو الآخر، أو ارفع CSV، أو استخدم Lite Plus لمزامنة Shopify وWooCommerce.',
      },
    ],

    ctaTitle: 'أرسل أول توصيلة مع Lite اليوم',
    ctaText: 'ابدأ من 49$ شهرياً مع 3 سائقين و500 طلب. انتقل إلى Lite Plus لتخطيط المسارات والتخصيص التلقائي وواتساب، أو إلى Lite Autopilot ليتولى الذكاء الاصطناعي التوزيع.',
    ctaTalk: 'تحدّث إلينا',
  },
  home: {
    liteTeaser: {
      heroPill: 'Geofleet Lite للفرق التي تعمل من موقع واحد، من 49$ شهرياً',
      badge: 'جديد',
      title: 'هل تدير التوصيل من متجر أو مستودع واحد؟',
      text: 'تعرّف على Geofleet Lite: الطلبات والمسارات والتتبع المباشر وإثبات التسليم في تطبيق واحد بسيط، ابتداءً من 49$ شهرياً مع 3 سائقين و500 طلب.',
      cta: 'اكتشف Geofleet Lite',
    },
  },
};
